var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGrassBottom = function SvgGrassBottom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3517 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMinYMin slice"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M237 28.5C141.8 26.9 70 0 0 0h3517c-105.5 0-256.5 18.5-413 17s-464 49.5-568 49.5-229.5-18-338.5-16.5S1869 75 1699 78s-365-21.5-511.5-43-340.5 0-456-14.5-375.5 10-494.5 8Z",
    fill: "#57C975"
  })));
};
export default SvgGrassBottom;